import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { fetchInitialData, setProfiles, setSelectedProfile } from '../../../redux/applicationSlice';
import { getAllProfiles } from '../../../Api/api';
import { FocusContext, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import EditButtonChooseProfileScreen from './EditButtonChooseProfileScree';
import Smiley from '../components/Smiley';
import { ANALYTICS_EVENTS, LOCAL_STORAGE_KEY } from '../../../constant';
import { utility } from '../../../utility/utility';
import AnalyticsManager from '../../../analytics/analyticsManager';

const ChooseProfilePage = () => {

    const navigate = useNavigate();
    const [isEditMode, setIsEditMode] = useState(false);
    const { user, logo, theme, profiles, selectedProfile, ottSettings, prevPath } = useSelector((state) => state.application);
    const dispatch = useDispatch();

    useEffect(() => {
        if (!ottSettings) {
            dispatch(fetchInitialData());
        }
    }, [dispatch]);

    useEffect(() => {
        loadAllProfiles();
    }, [])

    const { ref, focusKey, focusSelf, setFocus } = useFocusable({
        focusKey: "choose-profile",
        trackChildren: true,
        autoRestoreFocus: true,
        isFocusBoundary: true,
        onArrowPress: (direction) => {
            return true;
        },
    });

    useEffect(() => {
        focusSelf();
    }, [profiles, navigate]);

    const loadAllProfiles = async () => {
        let allProfiles = await getAllProfiles(user._id);
        if (allProfiles.success && allProfiles.data.length > 0) {
            dispatch(setProfiles(allProfiles.data));
        }
    }

    const onProfileClick = (profile) => {
        dispatch(setSelectedProfile(profile));
        utility.setValue(LOCAL_STORAGE_KEY.selectedProfile, profile);

        if (profile.addNew) {
            navigate('/profile/new');
            return;
        }
        if (isEditMode) {
            navigate('/profile/edit');
            return;
        }
        if (profile?.EnableParentalControl && profile?.Pin) {
            navigate('/profileLock', { state: { fromProfileSelection: true } })
            return;
        }
        // Analytics event
        AnalyticsManager().logEvent(ANALYTICS_EVENTS.PROFILE_SWITCH, profile);
        navigate(prevPath);
        return;
    }

    return (
        <FocusContext.Provider value={focusKey}>
            <div ref={ref} style={{ display: 'flex', alignItems: 'center', height: '100vh', backgroundColor: theme?.general?.bgColor ?? "#000000", color: theme?.general?.color ?? "#828282", paddingTop: "20px", flexDirection: "column" }} >
                <img src={logo} style={{ height: "100px" }} />
                <EditButtonChooseProfileScreen setIsEditMode={setIsEditMode} isEditMode={isEditMode} />
                <p style={{ fontSize: "32px", fontWeight: "bold", letterSpacing: "1px", marginTop: "10px" }}>Who's watching?</p>
                {profiles && profiles.length > 0 && <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", marginTop: "60px", gap: "50px" }}>
                    {profiles.map((profile, index) => <Smiley key={index} size='150px' profile={profile} addNew={profile?.addNew ?? false} isEditMode={isEditMode} onClick={() => { onProfileClick(profile) }} focusTo={'edit-profile'} />)}
                </div>}
            </div>
        </FocusContext.Provider >
    );
}

export default ChooseProfilePage;
